import clsx from 'clsx';
import { useEffect, useState } from 'react';
import { Popover, PopoverContent, PopoverTrigger } from '../ui/Popover';
import { UpArrow } from '../../icons';

const Steps = {
  1: 'Επιλογή Αυτοκινήτου',
  2: 'Δημιουργία Λογαριασμού',
  3: 'Υποβολή Στοιχείων & Εγγράφων',
  4: 'Υπογραφή Συμβολαίων',
  5: 'Πληρωμή',
};

export const OfferStepper = ({ currentStep, currentSubStep,kyc }) => {
  const [step, setStep] = useState();

  useEffect(() => {
    if (
      currentStep === 2 ||
      currentStep === 3 ||
      currentStep === 4 ||
      (currentStep === 5 && (currentSubStep === 0 || currentSubStep === ''))
    ) {
      setStep(3);
    } else if (
      currentStep === 5 &&
      currentSubStep !== 0 &&
      currentSubStep !== ''
    ) {
      setStep(4);
    } else if (currentStep === 6) {
      setStep(5);
    } else {
      setStep(2);
    }
  }, [currentStep, currentSubStep]);

  return (
    <div className="bg-[#F5F5F7] z-20 pt-6 pb-4 lg:px-20 sticky top-0">
      <div
        className={clsx(
          'max-lg:hidden rounded-full w-full h-fit',
          currentStep > 5 && 'bg-[#FFD0DB80]'
        )}
        style={{
          border: 'solid 1px transparent',
          background:
            currentStep <= 5 &&
            `linear-gradient(0deg, rgba(245, 245, 247, 0.5), rgba(245, 245, 247, 0.5)), linear-gradient(90deg, #FFD0DB 61.54%, rgba(255, 255, 255, 0) ${
              currentStep === 5 && currentSubStep !== 0 && currentSubStep !== ''
                ? '90.61%'
                : '75.61%'
            }),linear-gradient(0deg, #FFFFFF, #FFFFFF)`,
        }}
      >
        <div className="flex justify-between p-2.5 text-xs items-center">
          <div className="flex gap-2 items-center font-medium">
            <p className="h6 text-white bg-black rounded-full w-6 h-6 flex items-center justify-center">
              1
            </p>
            <p className="text-label">Επιλογή Αυτοκινήτου</p>
          </div>
          <div className="flex gap-2 items-center font-medium">
            <p
              className={clsx(
                'h6 text-white rounded-full w-6 h-6 flex items-center justify-center',
                currentStep === 0 ? 'bg-[#D4002A]' : ' bg-black '
              )}
            >
              2
            </p>
            <p className="text-label">Δημιουργία Λογαριασμού</p>
          </div>
          <div className="flex gap-2 items-center">
            <p
              className={clsx(
                'h6 text-white rounded-full w-6 h-6 flex items-center justify-center',
                currentStep === 2 ||
                  currentStep === 3 ||
                  currentStep === 4 ||
                  (currentStep === 5 &&
                    (currentSubStep === 0 || currentSubStep === ''))
                  ? 'bg-[#D4002A]'
                  : currentStep < 2
                  ? 'bg-[#A5A5A5]'
                  : 'bg-black'
              )}
            >
              3
            </p>
            <p className="text-label">{kyc ? 'Βεβαίωση Στοιχείων μέσω Gov.gr' : 'Υποβολή Στοιχείων & Εγγράφων'}</p>
          </div>
          <div className="flex gap-2 items-center font-medium">
            <p
              className={clsx(
                'h6 text-white rounded-full w-6 h-6 flex items-center justify-center',
                currentStep === 5 &&
                  currentSubStep !== 0 &&
                  currentSubStep !== ''
                  ? 'bg-[#D4002A]'
                  : currentStep < 5 ||
                    (currentStep === 5 &&
                      (currentSubStep === 0 || currentSubStep === ''))
                  ? 'bg-[#A5A5A5]'
                  : 'bg-black'
              )}
            >
              4
            </p>
            <p className="text-label">Υπογραφή Συμβολαίων</p>
          </div>
          <div className="flex gap-2 items-center font-medium">
            <p
              className={clsx(
                'h6 text-white rounded-full w-6 h-6 flex items-center justify-center',
                currentStep === 6
                  ? 'bg-[#D4002A]'
                  : currentStep < 6
                  ? 'bg-[#A5A5A5]'
                  : 'bg-black'
              )}
            >
              5
            </p>
            <p className="text-label">Πληρωμή</p>
          </div>
        </div>
      </div>
      <div className="w-full justify-between items-center flex pl-6 pr-4 lg:hidden">
        <div className="flex gap-2 items-center">
          <h5 className="rounded-full bg-[#D4002A] text-white w-6 h-6 flex justify-center">
            {step}
          </h5>
          <h5>{Steps[step]}</h5>
        </div>
        <Popover>
          <PopoverTrigger className="flex gap-2">
            <div className='flex flex-col text-center'>
              <p className="text-body text-center">Βήμα</p>
              <p className="text-body text-center">{step} από 5</p>
            </div>
            <UpArrow stroke="black" className={'w-5 rotate-180'} />
          </PopoverTrigger>
          <PopoverContent className="mr-3 rounded-[6px] z-[100]">
            {Object.entries(Steps).map(([key, value]) => (
              <p className="text-body">
                <span
                  className={clsx(
                    'font-[700]',
                    parseInt(key) === step && 'text-[#D4002A]'
                  )}
                >
                  {key}
                </span>{' '}
                {value}
              </p>
            ))}
          </PopoverContent>
        </Popover>
      </div>
    </div>
  );
};
